module.exports = __webpack_public_path__ + "img/upload.7f182e78.png";